// extracted by mini-css-extract-plugin
export default {"participatingPharmacies":"_abGRWe5","participatingPharmaciesWrapper":"ib5CWNSA","participatingPharmaciesTextWrapper":"x7Vthpzl","participatingPharmaciesLogos":"u6nBptiu"};